import request from '../request';

export function fetch(params, options) {
  return [request, 'get', 'organizations', params, options];
}

export function create(payload: any) {
  return request('post', 'organizations', payload);
}

export function update(id: string, payload: any) {
  return request('put', `organizations/${id}`, payload);
}

export function destroy(id: string) {
  return request('delete', `organizations/${id}`);
}

export function lock(id: string) {
  return request('post', `organizations/${id}/lock`);
}

export function unlock(id: string) {
  return request('post', `organizations/${id}/unlock`);
}
